// import { capitalCase } from 'change-case';
import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Card, Stack, MenuItem, Tooltip, Container, Typography } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
// routes
import { PATH_AUTH } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
import useLocales from '../../hooks/useLocales';
// layouts
import AuthLayout from '../../layouts/AuthLayout';
// components
import Page from '../../components/Page';
import { MHidden } from '../../components/@material-extend';
import { LoginForm } from '../../components/authentication/login';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

const FlexDiv = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

const GtBox = styled(Box)({
  width: '14.71px',
  height: '14.71px',
  fontSize: '0.5rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  fontWeight: 600
});

const MySelect = styled(Select)({
  width: '123px',
  height: '28px',
  borderRadius: '2px',
  color: 'gray',
  background: 'white'
});

// ----------------------------------------------------------------------

export default function Login() {
  const { method } = useAuth();
  const { trans, onChangeLang, currentLang } = useLocales();
  const handleChangeLang = (event: any) => {
    onChangeLang(event.target.value as string);
  };

  return (
    <RootStyle title={trans('login.pageTitle')}>
      {/* <AuthLayout>
        {trans('login.NothaveAccount')} &nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
          {trans('login.resign')}
        </Link>
      </AuthLayout> */}

      <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 4, mt: 10, mb: 5, fontSize: '21pt !important' }}>
            {trans('login.welcome_back')}
          </Typography>
          <img
            style={{ padding: '0 40px' }}
            src="/static/illustrations/illustration_bg.png"
            alt="login"
          />
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack
            direction="row"
            alignItems="center"
            sx={{ mb: 5 }}
            style={{ marginLeft: 'auto', marginRight: 'auto' }}
          >
            <Tooltip title="logo">
              <Box component="img" src={'/static/dashboard/logo.svg'} />
            </Tooltip>
            {/* <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h4" gutterBottom>
                Sign in to Minimal
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>Enter your details below.</Typography>
            </Box>

            <Tooltip title={capitalCase(method)}>
              <Box
                component="img"
                src={`/static/auth/ic_${method}.png`}
                sx={{ width: 32, height: 32 }}
              />
            </Tooltip> */}
          </Stack>

          {/* <Alert severity="info" sx={{ mb: 3 }}>
            Use email : <strong>demo@minimals.cc</strong> / password :
            <strong>&nbsp;demo1234</strong>
          </Alert> */}

          <LoginForm />
          <FlexDiv sx={{ mt: '42px' }}>
            <Box sx={{ width: '24px', height: '24px', position: 'relative' }}>
              <GtBox
                sx={{
                  border: '1px solid black',
                  position: 'absolute',
                  top: '1.5px',
                  left: '1.5px'
                }}
              >
                文
              </GtBox>
              <Box
                sx={{
                  width: '5.42px',
                  height: '5.42px',
                  border: '1px solid black',
                  position: 'absolute',
                  bottom: '3.5px',
                  left: '6.5px'
                }}
              />
              <GtBox
                sx={{
                  border: '1px solid black',
                  background: 'black',
                  color: '#fff',
                  position: 'absolute',
                  bottom: '-2.5px',
                  right: '-0.5px'
                }}
              >
                A
              </GtBox>
            </Box>
            <Box sx={{ ml: '10px' }}>
              <MySelect
                sx={{
                  '& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
                    pt: '8px',
                    pb: '5px',
                    pl: '7px',
                    fontSize: '1rem',
                    color: '#000000'
                  },
                  '& .css-vewk60-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root': {
                    pt: '6px'
                  }
                }}
                value={currentLang.value}
                onChange={handleChangeLang}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <MenuItem value="zh" sx={{ fontSize: '1rem', color: '#000000' }}>
                  {trans('login.lang.zh')}
                </MenuItem>
                <MenuItem value="cn" sx={{ fontSize: '1rem', color: '#000000' }}>
                  {trans('login.lang.cn')}
                </MenuItem>
                <MenuItem value="english" sx={{ fontSize: '1rem', color: '#000000' }}>
                  {trans('login.lang.english')}
                </MenuItem>
              </MySelect>
            </Box>
          </FlexDiv>
          <FlexDiv>
            <Typography variant="body1" sx={{ color: '#7b7b7b', pt: '10px', pl: '9px' }}>
              EVI Services Limited © 2025 (
              {trans('common.version', { version: process.env.REACT_APP_VERSION })})
            </Typography>
          </FlexDiv>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
